// import {Component} from '@angular/core';
// import { Router } from '@angular/router';
// import { navItems } from '../../_nav';
// import { Location } from '@angular/common';

// @Component({
//   selector: 'app-dashboard',
//   templateUrl: './default-layout.component.html'
// })
// export class DefaultLayoutComponent {
//   public sidebarMinimized = false;

//   constructor(private router: Router, private location: Location){ }

//   public navItems = localStorage.getItem('User') != undefined ? (parseInt(localStorage.getItem('Role')) != 0 ? navItems.filter(x=> x.name != "Administración") : navItems) : [];

//   toggleMinimize(e) {
//     this.sidebarMinimized = e;
//   }

//   logOut(){
//     localStorage.clear();
//     this.location.replaceState('/'); // clears browser history so they can't navigate with back button
//     this.router.navigate(['login']);
//   }

// }

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { navItems } from '../../_nav';
import { Location } from '@angular/common';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent implements OnInit {
  public sidebarMinimized = false;
  public filteredNavItems = [];

  constructor(private router: Router, private location: Location) {}

  ngOnInit(): void {
    // Filtrar navItems según el rol del usuario
    this.filteredNavItems = this.getFilteredNavItems();
  }

  /**
   * Filtra los navItems según el rol del usuario
   */
  private getFilteredNavItems(): any[] {
    const user = localStorage.getItem('User');
    const role = localStorage.getItem('Role');

    if (user === undefined || user === null) {
      return [];
    }

    const roleNum = parseInt(role, 10);
    return roleNum !== 0 ? navItems.filter(x => x.name !== "Administración") : navItems;
  }

  toggleMinimize(e: boolean): void {
    this.sidebarMinimized = e;
  }

  logOut(): void {
    localStorage.clear();
    this.location.replaceState('/');
    this.router.navigate(['login']);
  }
}
